import Cookies from 'js-cookie'

import {cookiesMap} from '@helios/shared/config/cookies'
import {usePageInfo} from '@helios/shared/providers/page-info'
import type {HubspotContactProps} from '@helios/shared/types/hubspot-contact-props'
import {
    MarketingCampaigns,
    Events,
    LifecycleStages,
    Integrations,
    HubspotPartnerChannel,
    HubspotPartnerSegment,
    HubspotPartnershipType,
    HubspotTypeOfInfluence,
} from '@helios/shared/types/marketing-campaigns'

export const useHubspotProperties = (isBlog: boolean = false) => {
    const {location} = usePageInfo()
    const landingPage = Cookies.get(cookiesMap.rawLandingPageKey)
    const urlParams = new URLSearchParams(location.search)
    const sourceIsBlog = urlParams.get('utm_source') === 'blog'
    const utmCampaign = urlParams.get('utm_campaign')
    const integrationPage =
        location.pathname.split('/')[2] === 'integrations' && location.pathname.split('/')[3]

    const hubspotFields: Partial<HubspotContactProps> = {
        lifecyclestage: LifecycleStages.MQL,
    }

    // Integration fields - we can create common integrations page attributes
    // (partner_channel, type_of_influence, etc) if there will be more pages sharing attributes
    if (integrationPage === Integrations.Travelperk.toLowerCase()) {
        const date = new Date().toISOString().split('T')[0]

        hubspotFields.pleo_partner_id = Integrations.Travelperk
        hubspotFields.partner_channel = HubspotPartnerChannel.TechnologyPartners
        hubspotFields.type_of_influence = HubspotTypeOfInfluence.PartnerSource
        hubspotFields.partner_segment = HubspotPartnerSegment.Referral
        hubspotFields.partnership_type = HubspotPartnershipType.Distribution
        hubspotFields.partnership_referred_date = date
    }

    if (integrationPage === Integrations.Bolt.toLowerCase()) {
        const date = new Date().toISOString().split('T')[0]

        hubspotFields.pleo_partner_id = Integrations.Bolt
        hubspotFields.partner_channel = HubspotPartnerChannel.TechnologyPartners
        hubspotFields.type_of_influence = HubspotTypeOfInfluence.PartnerSource
        hubspotFields.partner_segment = HubspotPartnerSegment.Referral
        hubspotFields.partnership_type = HubspotPartnershipType.Distribution
        hubspotFields.partnership_referred_date = date
    }

    if (integrationPage === Integrations.Sesame.toLowerCase()) {
        const date = new Date().toISOString().split('T')[0]

        hubspotFields.pleo_partner_id = Integrations.Sesame
        hubspotFields.partner_channel = HubspotPartnerChannel.TechnologyPartners
        hubspotFields.type_of_influence = HubspotTypeOfInfluence.PartnerSource
        hubspotFields.partner_segment = HubspotPartnerSegment.Referral
        hubspotFields.partnership_type = HubspotPartnershipType.Distribution
        hubspotFields.partnership_referred_date = date
    }

    // LP fields
    if (landingPage === 'cashback') {
        hubspotFields.latest_campaign = MarketingCampaigns.Cashback
        hubspotFields.utm_campaign = MarketingCampaigns.Cashback
        hubspotFields.campaign__updating_ = MarketingCampaigns.Cashback
        hubspotFields.event_name = Events.CashbackLandingPage

        if (sourceIsBlog || isBlog) {
            hubspotFields.event_name = Events.Blog
        }
    }

    if (
        landingPage === 'multi-entity-businesses' ||
        (sourceIsBlog && utmCampaign === 'multi-entity-businesses')
    ) {
        hubspotFields.latest_campaign = MarketingCampaigns.MultiEntity
        hubspotFields.utm_campaign = MarketingCampaigns.MultiEntity
        hubspotFields.campaign__updating_ = MarketingCampaigns.MultiEntity
        hubspotFields.event_name = sourceIsBlog ? Events.Blog : Events.MultiEntityLandingPage
    }

    return hubspotFields
}
